import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Download = _resolveComponent("Download")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    trigger: "click",
    placement: "bottom-end",
    class: "download-actions"
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, { class: "download-actions__menu" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown_item, { class: "download-actions__menu-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _ctx.icons.Download,
                class: "download-actions__menu-item-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getReport(true)))
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Report with timestamp ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["icon"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_dropdown_item, { class: "download-actions__menu-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _ctx.icons.Download,
                class: "download-actions__menu-item-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getReport(false)))
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Report ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["icon"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: _ctx.type,
        plain: "",
        loading: _ctx.isLoading
      }, {
        default: _withCtx(() => [
          (!_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "el-icon--left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Download)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _cache[2] || (_cache[2] = _createTextVNode(" Report ", -1 /* CACHED */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["type", "loading"])
    ]),
    _: 1 /* STABLE */
  }))
}